export interface EntityWithEdgeIds {
  readonly id: string;
  readonly edgeIds: string[];
}

export function roomEdgeIndexFromId(room: EntityWithEdgeIds, id: string | undefined): number | null {
  if (id === undefined) {
    return null;
  }

  const edgeIndex = room.edgeIds.indexOf(id);
  if (edgeIndex === -1) {
    console.warn(`edgeName is invalid for roomId=${room.id}`);
    return null;
  }
  return edgeIndex;
}
